var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleRedAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 6.66667C13.3333 10.3486 10.3486 13.3333 6.66667 13.3333C2.98477 13.3333 0 10.3486 0 6.66667C0 2.98477 2.98477 0 6.66667 0C10.3486 0 13.3333 2.98477 13.3333 6.66667ZM7.5 3.33333C7.5 3.79357 7.1269 4.16667 6.66667 4.16667C6.20643 4.16667 5.83333 3.79357 5.83333 3.33333C5.83333 2.8731 6.20643 2.5 6.66667 2.5C7.1269 2.5 7.5 2.8731 7.5 3.33333ZM5.83333 5.83333C5.3731 5.83333 5 6.20643 5 6.66667C5 7.1269 5.3731 7.5 5.83333 7.5V10C5.83333 10.4602 6.20643 10.8333 6.66667 10.8333H7.5C7.96024 10.8333 8.33333 10.4602 8.33333 10C8.33333 9.53976 7.96024 9.16667 7.5 9.16667V6.66667C7.5 6.20643 7.1269 5.83333 6.66667 5.83333H5.83333Z",
    fill: "#EC094D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRedAlert);
export default __webpack_public_path__ + "static/media/circle-red-alert.ed832a91728d7bc277c46c38c1f3ff7d.svg";
export { ForwardRef as ReactComponent };